import { initialState } from "../store/initialState";
import { AnyAction } from "redux";
import { internalActionKeys } from "../actions/internalActionKeys";
import { TimeZone } from "src/common/types/timeZone";

export default function internalAppSettingsReducer(
  state: TimeZone[] = initialState.systemTimeZones,
  action: AnyAction
): TimeZone[] {
  switch (action.type) {
    case internalActionKeys.GET_SYSTEM_TIME_ZONES:
      return action.systemTimeZones;
    default:
      return state;
  }
}
